import React from "react";
import { AppBasicTable } from "@components";
import { useEuropcarPricingEnvTableData } from "../@hooks";
import {Grid, Skeleton, useTheme} from "@mui/material";
import { officeColumn, pricesColumn } from "./columns";
import { datesHeader, officeProvidersHeader } from "./headers";
import PricingEnvironmentTableTitle from "./Title";
import {formatDate, postExcel} from "@ui-seeker/utils";
import {BACKEND_APIS} from "@constants";
import {europcarPricingEnvFilters} from "../@signals";
import {rentalDates} from "../../../../../@signals";


export default function EuropcarPricingEnvironmentTable() {

    const { isLoading, tableHeaders, tableData, tableSubHeaders, providers } = useEuropcarPricingEnvTableData()
    const { palette} = useTheme()

    if (isLoading) return <Skeleton variant="rectangular" height={500} />
    if(!tableData?.length) return null

    return <>
        {tableHeaders.length <= 3 && <Grid item xl={1.5} />}
        <Grid item xs={tableHeaders.length <= 3 ? 10 : 12}>
            <AppBasicTable
                onDownload={() => postExcel(`${BACKEND_APIS.DASHBOARD}/excel`, { ...europcarPricingEnvFilters.value, pickupDate: rentalDates.value.map(date => formatDate(date, { format: 'yyyyMMdd' })) })}
                toolbarProps={{ actions: false }}
                titleProps={{ actions: false }}
                data={tableData}
                headers={[[officeProvidersHeader(), ...tableHeaders.map(header => datesHeader(header, tableSubHeaders))]]}
                columns={[
                    officeColumn(providers), ...tableHeaders.map(date => pricesColumn(date, providers, tableSubHeaders, palette))
                ]}
                Components={{
                    Title: () => <PricingEnvironmentTableTitle />
                }}
            />
        </Grid>
        {tableHeaders.length <= 3 && <Grid item xl={1.5} />}
    </>
}